/**
 * CONSTANTS
 */

export const companyId = (window.portal_proveedores.companyId) ? window.portal_proveedores.companyId : 1;
export const companyHost = (window.portal_proveedores.url) ? window.portal_proveedores.url : "https://aguafria.saasmexico.net/"; //"http://aguafria.saasmexico.net/";
export const login_name = (window.portal_proveedores.title) ? window.portal_proveedores.title : "PORTAL DE PROVEEDORES";
export const company_name = (window.portal_proveedores.subtitle) ? window.portal_proveedores.subtitle : "AguaFria - Fábrica de Hielo Apodaca";
